import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FUNNEL } from "@/data/funnel";

let cache = null;
let inflight = null;
const load = () => (inflight ||= api.get(`/funnel/${FUNNEL.slug}/config`).then((r) => (cache = r.data)).catch(() => (cache = {})));

export const useFunnelConfig = () => {
  const [config, setConfig] = useState(cache);
  useEffect(() => { if (!cache) load().then(setConfig); }, []);
  return config;
};

const inited = new Set();
export const useFunnelPixel = () => {
  const config = useFunnelConfig();
  const id = config?.meta_pixel_id;
  useEffect(() => {
    if (!id || inited.has(id) || typeof window.fbq !== "function") return;
    inited.add(id);
    try { window.fbq("init", id); window.fbq("trackSingle", id, "PageView"); } catch (_) { /* noop */ }
  }, [id]);
};
